<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="contratForm" @submit="editContrat" :validation-schema="contratSchema">
        <div class="row">
          <div class="col-md-4 col-sm-12 col-xm-12 mt-3">
            <label for="date_initialisation" class="form-label">Date Contrat<span class="text-danger">*</span></label>
            <Field name="date_initialisation" class="form-control" type="Date" />
            <ErrorMessage name="date_initialisation" class="text-danger" />
          </div>
          <div class="col-md-4 col-sm-12 col-xm-12 mt-3">
            <label for="dateMiseEnService" class="form-label">Date Mise En Service<span
                class="text-danger">*</span></label>
            <Field name="dateMiseEnService" class="form-control" type="Date" />
            <ErrorMessage name="dateMiseEnService" class="text-danger" />
          </div>
          <div class="col-md-4 col-sm-12 col-xm-12 mt-3">
            <label class="d-block text-black fw-semibold mb-10" v-if="selectedPlace">
              Place<span class="text-danger">*</span>
              <button style="float: right;" type="button"
                class="default-btn transition border-0 fw-medium text-white rounded-1 bg-success d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                @click.stop="togglePlace('utiliser')">
                <i class="flaticon-plus position-relative ms-5 fs-12"></i>
                Utiliser l'actuel
              </button>

            </label>
            <label class="d-block text-black fw-semibold mb-10" v-else>
              Place<span class="text-danger">*</span>
              <button style="float: right;" type="button"
                class="default-btn transition border-0 fw-medium text-white rounded-1 bg-success d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                @click.stop="togglePlace('modifier')">
                <i class="flaticon-plus position-relative ms-5 fs-12"></i>
                Modifier
              </button>
            </label>
            <Field name="place" v-slot="{ field }" v-if="selectedPlace" >
              <Multiselect v-bind="field" placeholder="Rechercher une place" v-model="placeId" :filter-results="false"
                :min-chars="3" :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300"
                @select="placeSelectionner($event)" :options="async (query) => {
                  return await fetchPlaces(query)
                }" noResultText="Aucun enregistrement trouvé" noOptionsText="Tapez au moins trois caractères" />
            </Field>
            <Field name="place" v-slot="{ field }" v-model="placeS" v-else>
              <Multiselect v-model="field.value" :options="placeOption" disabled placeholder="Rechercher une place" />
            </Field>
            <ErrorMessage name="place" class="text-danger" />
          </div>

          <div class="col-md-4 col-sm-12 col-xm-12 mt-3">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-10" v-if="selectedMarchand">
                Marchand<span class="text-danger">*</span>
                <button style="float: right;" type="button"
                  class="default-btn transition border-0 fw-medium text-white rounded-1 bg-success d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                  @click="toggleMarchand('utiliser')">
                  <i class="flaticon-plus position-relative ms-5 fs-12"></i>
                  Utiliser l'actuel
                </button>
              </label>
              <label class="d-block text-black fw-semibold mb-10" v-else>
                Marchand<span class="text-danger">*</span>
                <button type="button" style="float: right;"
                  class="default-btn transition border-0 fw-medium text-white rounded-1 bg-success d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                  @click="toggleMarchand('modifier')">
                  <i class="flaticon-plus position-relative ms-5 fs-12"></i>
                  Modifier
                </button>
              </label>
              <Field name="usager" v-slot="{ field }" v-if="selectedMarchand">
                <Multiselect v-model="field.value" v-bind="field" placeholder="Rechercher un marchand"
                  :filter-results="false" :min-chars="3" :resolve-on-load="false" :delay="0" :searchable="true"
                  :options-limit="300" :options="async (query) => {
                    return await fetchUsagers(query)
                  }" noResultText="Aucun enregistrement trouvé" noOptionsText="Tapez au moins trois caractères" />
              </Field>
              <Field name="usager" v-slot="{ field }" v-model="usagerS" v-else>
                <Multiselect v-model="field.value" :options="marchandOption" placeholder="Rechercher un marchand" disabled />
              </Field>
              <ErrorMessage name="usager" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 col-sm-12 col-xm-12 mt-3">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-5">
                Groupe de Taxe du loyer <span class="text-danger">*</span>
              </label>

              <Field name="groupeTaxe" v-slot="{ field }" v-model="groupeDeTaxeSelected">
                <Multiselect v-bind="field" placeholder="Rechercher un groupe de taxe"
                  contratholder="Rechercher un groupe" :filter-results="false" :min-chars="3" :resolve-on-load="false"
                  :delay="0" :searchable="true" :options-limit="300" :options="groupeTaxeOption"
                  noResultText="Aucun enregistrement trouvé" noOptionsText="Tapez au moins trois caractères" />
              </Field>
              <ErrorMessage name="groupeTaxe" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 col-sm-12 col-xm-12 mt-3">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-10" v-if="selectedActivite">
                Activite<span class="text-danger">*</span>
                <button style="float: right;" type="button"
                  class="default-btn transition border-0 fw-medium text-white rounded-1 bg-success d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                  @click="toggleActivite('utiliser')">
                  <i class="flaticon-plus position-relative ms-5 fs-12"></i>
                  Utiliser l'actuel
                </button>

              </label>
              <label class="d-block text-black fw-semibold mb-10" v-else>
                Activite<span class="text-danger">*</span>
                <button style="float: right;" type="button"
                  class="default-btn transition border-0 fw-medium text-white rounded-1 bg-success d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                  @click="toggleActivite('modifier')">
                  <i class="flaticon-plus position-relative ms-5 fs-12"></i>
                  Modifier
                </button>
              </label>
              <Field name="activite" v-slot="{ field }" v-if="selectedActivite">
                <Multiselect v-model="field.value" v-bind="field" placeholder="Rechercher une activité"
                  :filter-results="false" :min-chars="3" :resolve-on-load="false" :delay="0" :searchable="true"
                  :options-limit="300" :options="async (query) => {
                    return await fetchActivites(query)
                  }" noResultText="Aucun enregistrement trouvé" noOptionsText="Tapez au moins trois caractères" />
              </Field>
              <Field name="activite" v-slot="{ field }" v-model="activiteS"  v-else>
                <Multiselect v-model="field.value" disabled :options="activiteOption" placeholder="Rechercher une activité" />
              </Field>
              <ErrorMessage name="activite" class="text-danger" />
            </div>
          </div>

          <div class="col">
            <label for="loyer" class="form-label">Loyer<span class="text-danger">*</span></label>
            <Field name="loyer" class="form-control" type="number" v-model="loyerBasePlace"
              @keydown="['-', 'e', 'E', '+'].includes($event.key) && $event.preventDefault()" />
            <ErrorMessage name="loyer" class="text-danger" />
          </div>
          <div class="col">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black mb-10">
                AIB
              </label>
              <Field name="aib" v-model="aib" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :options="[
                  { value: 1, label: '1 %' },
                  { value: 5, label: '5 %' },
                ]" v-model="field.value" v-bind="field" contratholder="Sélectionner un élément" />
              </Field>
              <ErrorMessage name="aib" class="text-danger" />
            </div>
          </div>
          <div class="col">
            <label for="montantAib" class="form-label">Montant AIB<span class="text-danger">*</span></label>
            <Field name="loyerAib" class="form-control" type="number" v-model="loyerAib"
              @keydown="['-', 'e', 'E', '+'].includes($event.key) && $event.preventDefault()" />
            <ErrorMessage name="loyerAib" class="text-danger" />
          </div>
          <div class="col">
            <label for="caution" class="form-label">Caution<span class="text-danger">*</span></label>
            <Field name="caution" class="form-control" type="number" v-model="caution"
              @keydown="($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault()" />
            <ErrorMessage name="caution" class="text-danger" />
          </div>
          <div class="col" v-if="estTPS">
            <label for="montantTPS" class="form-label">Montant TPS<span class="text-danger">*</span></label>
            <Field name="montantTPS" class="form-control" type="number" v-model="montantTPS"
              @keydown="($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault()" />
            <ErrorMessage name="montantTPS" class="text-danger" />
          </div>

          <div class="col">
            <label for="montantContrat" class="form-label">Montant Contrat<span class="text-danger">*</span></label>
            <Field name="montantContrat" class="form-control" type="number" v-model="montantContrat"
              @keydown="($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault()" />
            <ErrorMessage name="montantContrat" class="text-danger" />
          </div>

          <div class="col-md-12 mb-3 mt-3">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-5">
                Observation
              </label>
              <Field name="observation" cols="20" rows="3" as="textarea" placeholder="Observation" v-slot="{ field }"
                class="form-control shadow-none rounded-0 text-black">
                <textarea v-model="field.value" class="form-control shadow-none rounded-0 text-black"></textarea>
              </Field>
              <ErrorMessage name="observation" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12 mb-md-25">
            <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
              <div class="row">
                <div class="border border-primary mb-10">
                  <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                    style="background-color: #0a59a4">
                    <div class="col-md-7">
                      <h3 class="fs-4 text-white">
                        Elements Electriques
                      </h3>
                    </div>
                    <div class="col-md-5">
                      <div class="d-flex float-end">
                        <button
                          class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                          type="button" :class="{ 'cursor-not-allowed': isDisable }" :disabled="isDisable"
                          @click="addRowElement()">
                          <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i>
                          Ajouter un élément
                        </button>
                        <router-link to="/liste-mouvements"></router-link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="row d-flex align-items-center justify-content-between mt-10" v-if="showHeader">
                      <div class="col-md-3">
                        <label class="d-block text-black fw-semibold">
                          Elements
                          <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col">
                        <label class="d-block text-black fw-semibold">
                          Prix unitaire
                          <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col">
                        <label class="d-block text-black fw-semibold mb-5">
                          Quantite<span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col-md-2">
                        <label class="d-block text-black fw-semibold mb-5">
                          Montant <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col-md-3">
                        <label class="d-block text-black fw-semibold mb-5">
                          Groupe de Taxe <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col">
                        <label class="d-block text-black fw-semibold mb-5">
                          Actions <span class="text-danger">*</span>
                        </label>
                      </div>
                    </div>
                    <hr class="mt-0" />
                    <div class="row" v-for="(enfant, index) in enfants" :key="index">
                      <div class="col-md-3 mb-2">
                        <div class="form-group ">
                          <Multiselect :options="elementOptions" :searchable="true"
                            @select="chargerCler(enfant.element, index)" :multiple="true" v-model="enfant.element"
                            placeholder="Sélectionner l'élément" />
                          <span class="invalid-feedback" v-if="valideteRowElement(enfant.element)"></span>
                        </div>
                      </div>

                      <div class="col mb-2">
                        <div class="form-group">
                          <input v-model="enfant.prix" type="number"
                            class="form-control shadow-none fs-md-15 text-black" :readonly=true placeholder="" />
                        </div>
                        <div class="invalid-feedback" v-if="valideteRowElement(enfant.prix)">
                          Le prix est obligatoire.
                        </div>
                      </div>
                      <div class="col mb-2">
                        <div class="form-group ">
                          <input v-model="enfant.quantite" type="number"
                            class="form-control shadow-none fs-md-15 text-black" placeholder="saisir la quantité"
                            min="1"
                            @keydown="(event) => ['0', 'e', 'E', '-'].includes(event.key) && event.preventDefault()" />
                          <div class="invalid-feedback" v-if="valideteRowElement(enfant.quantite)">
                            La quantité est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 mb-2">
                        <div class="form-group ">
                          <input v-model="enfant.montant" type="text"
                            class="form-control shadow-none fs-md-15 text-black" placeholder="Saisir le montant" />
                          <div class="invalid-feedback" v-if="valideteRowElement(enfant.montant)">
                            Le montant est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 mb-2">
                        <div class="form-group ">
                          <Multiselect :options="groupeTaxeOption" :searchable="true" :multiple="true"
                            v-model="enfant.groupeTaxe" :disabled="estTPS == true"
                            placeholder="Sélectionner un groupe" />
                          <span class="invalid-feedback" v-if="valideteRowElement(enfant.groupeTaxe)"></span>
                        </div>
                      </div>
                      <div class="col mb-2">
                        <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button"
                          @click="removeRowElement(index)">
                          <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-md-12 mt-3">
              <div class="d-flex align-items-center ">
                <button class="btn btn-success me-3" type="submit" v-show="!auclic">
                  Enregistrer
                </button>
                <button class="btn btn-success" type="button" v-show="auclic" disabled>
                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  <span class="visually-hidden">Loading...</span>
                </button>
                <router-link to="/liste-contrats" class=" btn btn-danger"><i
                    class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                  <span class="position-relative"></span>Annuler</router-link>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, reactive, watch, nextTick } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import axios from 'axios';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter, useRoute } from 'vue-router';
import { Contrat } from '@/models/Contrat';
import Multiselect from '@vueform/multiselect';
import { GroupeDeTaxe } from '@/models/GroupeDeTaxe';
import { generateKey } from 'crypto';

export default defineComponent({
  name: "EditContrat",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,

  },

  setup: () => {
    const estTPS = ref(false);
    const placeId = ref();
    const placeS = ref();
    const contratSchema = Yup.object().shape({
      date_initialisation: Yup.date().required("La date du contrat obligatoire."),
      loyer: Yup.number().typeError("veuillez entrer des nombres").required("Le loyer est obligatoire."),
      montantContrat: Yup.number().typeError("veuillez entrer des nombres").required("Le montant du contrat est obligatoire."),
      dateMiseEnService: Yup.date().required("La date de mise en place est obligatoire."),
      place: Yup.string().required("La place est obligatoire."),
      observation: Yup.string().notRequired(),
      usager: Yup.string().required("le marchand est obligatoire."),
      activite: Yup.string().required("Activite est obligatoire."),
      groupeTaxe: Yup.number().required("Selectionnez un groupe de taxe."),
      montantTPS: estTPS.value ? Yup.number().required("Le montant de la TPS est obligatoire.") : Yup.number().notRequired(),
      caution: Yup.number().typeError("veuillez entrer des nombres").required("Le montant du contrat est obligatoire."),
      aib: Yup.number().typeError("veuillez entrer des nombres").notRequired(),
      loyerAib: Yup.number().typeError("veuillez entrer des nombres").required("Le montant AIB est obligatoire."),
    });

    const activitesOptions = ref([]);
    const elementOptions = ref([]);
    onMounted(() => {
      getAllElement(),
        getAllActivite(),
        getAllGroupeTaxe();
    });
    const contratForm = ref();
    const showMErr = ref(false);
    const types = ref();
    const usagers = ref();
    const categories = ref();
    const montantTPS = ref(0);
    const caution = ref();
    const groupeTaxeOption = ref<Array<any>>([]);
    const groupeDeTaxeSelected = ref(0);
    const showHeader = ref(false);
    const isDisable = ref(false);
    const auclic = ref(false);
    const placeSelected = ref(false);
    const loyerBasePlace = ref<number | null>(null);
    const montantContrat = ref<number>();
    const aib = ref(0);
    const loyerAib = ref(0);

    interface Enfant {
      identifiant: string;
      element: string;
      prix: string;
      quantite: string;
      montant: string;
      groupeTaxe: string;
      type: string;
    }
    const selectedPlace = ref(false);
    const placeOption = ref<Array<any>>([]);
    const selectedMarchand = ref(false);
    const selectedActivite = ref(false);
    const noOptionsTextAbb = ref("Tapez au moins trois caractères");
    const nooptions = "Aucun enregistrement trouvé";
    const noResultText = "Aucun enregistrement trouvé";
    const enfants = reactive<Enfant[]>([]);
    const marchandOption = ref<Array<any>>([]);
    const activiteOption = ref<Array<any>>([]);
    const usagerS = ref();
    const activiteS = ref();


    const getContrat = async (id: number) => {
      try {
        const response = await ApiService.get("/contrats/" + id.toString());
        const data = response.data;
        console.log("data contr===>", data.data);
        aib.value = data.data.aib
        const conEle = data.data?.contratElements;
        for (const c of conEle) {
          // console.log("eleele", c);
          enfants.push({
            identifiant: c?.id,
            element: c?.element?.id + '-' + c?.element?.cout,
            prix: c.prix,
            quantite: c.quantite,
            montant: (c.quantite * c.prix).toString(),
            groupeTaxe: c?.groupeTaxe?.id,
            type:"Ancien"
          })
        }
        placeOption.value = [
          {
            value: data.data.place.id,
            label: `${data.data.place.code} - [${data.data.place.type.marche?.libelle}] - ${data.data.place?.type?.type?.libelle}`,
          }
        ];
        // console.log("placeOption.value === ", placeOption.value);
        marchandOption.value = [
          {
            value: data.data.usager.id,
            label: (data.data.usager.typeUsager == null || data.data.usager.typeUsager == "Personne physique") ? (data.data.usager.nom + " " + data.data.usager.prenom + ' [ ' + ((data.data.usager.numtel) ? data.data.usager.numtel : 'NF') + ' ]' + `${data.data.usager.npi ? " - " + data.data.usager.npi : ""}`) : (data.data.usager.raisonSocial + `${data.data.usager.rccm ? ' [ ' + data.data.usager.rccm + ' ]' : ''}` + `${data.data.usager.ifu ? " - IFU : " + data.data.usager.ifu : ""}`),
          }
        ];
        // console.log("activiteOption === ", data.data.activite);
        if(data.data.activite) {
          activiteOption.value = [
            {
              value: data.data.activite.id,
              label: data.data.activite.libelle,
            }
          ];
        } else {
          activiteOption.value = [];
        }
        // activiteOption.value = [
        //   {
        //     value: data.data.activite.id,
        //     label: data.data.activite.libelle,
        //   }
        // ];
        placeS.value = data.data.place.id;
        // aib.value = data.data.aib;
        usagerS.value = data.data.usager.id;
        activiteS.value = data.data.activite?.id;
        placeId.value = `${data.data.place.id + '-' + data.data.place.loyerBase}`;

        for (const key in data.data) {
          let value = data.data[key];

          if (key === 'dateAcquisition' || key === 'dateMiseEnService') {
            value = value ? value.split('T')[0] : '';
          }

          contratForm.value?.setFieldValue(
            key,typeof value === 'object' && value !== null ? value.id : value
          );
        }

      } catch (reponse) {
        console.log("Erreur lors de la récupération du contrato", reponse);
        // if(reponse){
        //   error(reponse.message);
        // }
      }
    }

    //un watch sur groupeTaxe et aib
    watch([groupeDeTaxeSelected, aib], async (newValues) => {
      const [groupeTaxe, aibValue] = newValues;
      console.log("Groupe de taxe:", groupeTaxe, "AIB:", aibValue);
      if (groupeTaxe && aibValue) {
        console.log("les deux fourni");
        if([2, 4].includes(Number(groupeTaxe))) {
          console.log("Groupe de taxe 2 ou 4");
          loyerAib.value = Math.round((parseFloat((loyerBasePlace.value ?? 0).toString()) / (1 + (aibValue / 100) + 0.18 )) * (aibValue / 100));
        } else {
          loyerAib.value = Math.round((parseFloat((loyerBasePlace.value ?? 0).toString()) * (aibValue / 100)));
        }
      } else {
        loyerAib.value = 0;
      }
      // await calculTotal();
    });

    watch(loyerBasePlace, async (newValue) => {
      console.log("EEE ==> ", newValue);
      if (newValue) {
        loyerBasePlace.value = parseFloat((newValue).toString());
        caution.value = parseFloat((newValue * 2).toString());
        // montantContrat.value = parseFloat((newValue + (caution.value ?? 0) + (estTPS.value ? montantTPS.value : 0)).toString());
      } else {
        loyerBasePlace.value = 0;
      }

      await calculTotal();

      //simuler le watch de aib
      // const oldAib = aib.value;
      // aib.value = 0;
      // await nextTick();
      // aib.value = oldAib;

    });


    const togglePlace = (vale: string) => {
      console.log("Valeur de la place", vale);
      if (vale == "modifier") {
        selectedPlace.value = true;
      }
      if (vale == "utiliser") {
        selectedPlace.value = false;
      }
    }

    const toggleMarchand = (vale: string) => {
      console.log("Valeur de la marchand", vale);
      if (vale == "utiliser") {
        selectedMarchand.value = false;
      } 
      if(vale == "modifier") {
        selectedMarchand.value = true;
      }
    }

    const toggleActivite = (vale: string) => {
      console.log("Valeur de la activite", vale);
      if (vale == "utiliser") {
        selectedActivite.value = false;
      } 
      
      if(vale == "modifier") {
        selectedActivite.value = true;
      }
    }
    const getAllElement = async () => {
      try {
        const response = await ApiService.get('/all/element');
        const elementsData = response.data.data.data;

        elementOptions.value = elementsData.map((element) => ({
          value: element.id + '-' + element.cout,
          label: element.designation,
          disabled: false
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }

    const getAllGroupeTaxe = async (page = 1, limi = 10, searchTerm = '') => {
      return ApiService.get(`/all/groupeDeTaxe?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          groupeTaxeOption.value = data.data.data.map((groupe) => (
            {
              value: groupe.id,
              label: groupe.libelle,
            }
          ))
          return groupeTaxeOption.value;
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    const getAllActivite = async () => {
      try {
        const response = await ApiService.get('/all/activites');
        const activitesData = response.data.data.data;
        activitesOptions.value = activitesData.map((activite) => ({
          value: activite.id,
          label: activite.libelle,
          disabled: false
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }

    const typeOptions = ref([]);
    const usagermentSelected = ref('');
    const typeentretiens = ref();
    const typeentretienOptions = ref([]);

    const categorieOptions = ref([]);
    const serviceOptions = ref([]);
    const activitementSelected = ref('')
    const activiteSelected = ref(0);

    const router = useRouter();
    const route = useRoute();
    const services = ref();

    const editContrat = async (values, { resetForm }) => {
      auclic.value = true;
      values.elements = enfants.map((e) => ({
        element: e.element.split('-')[0],
        prix: e.prix,
        quantite: e.quantite,
        montant: e.montant,
        groupeTaxe: e.groupeTaxe
      }));

      for (let elem of values.elements) {
        if (elem.element == "") {
          error("Veuillez selectionner un element pour chaque ligne");
          showMErr.value = true;
          auclic.value = false;
          return;
        }
        if (elem.prix == "") {
          error("Veuillez saisir le prix pour chaque ligne");
          showMErr.value = true;
          auclic.value = false;
          return;
        }
        if (elem.quantite == "") {
          error("Veuillez saisir la quantité pour chaque ligne");
          showMErr.value = true;
          auclic.value = false;
          return;
        }
        if (elem.montant == "") {
          error("Veuillez saisir le montant pour chaque ligne");
          showMErr.value = true;
          auclic.value = false;
          return;
        }
        if (elem.groupeTaxe == "") {
          error("Veuillez selectionner un groupe de taxe pour chaque ligne");
          showMErr.value = true;
          auclic.value = false;
          return;
        }
      }
      try{
        console.log("Valeurs du contrat avant l'envoi:", values);
        values.aib = values.aib ?? 0;
        const edition = await axios.put("/contrats/" + values.id, values);
        console.log("DONNEEEE ===> ", edition);
        if (edition.data.code == 200) {
            success(edition.data.message);
            resetForm();
            router.push({ name: "ListeContratPage" });
            // router.push({ name: "ListeContrat" });ListeContratPage
          }

      }catch(err){
        //
        console.log("Erreur lors de la modification du contrat", err);
      }
    };

    const addRowElement = () => {
      enfants.push({
        identifiant: "",
        element: "",
        prix: "",
        quantite: "",
        montant: "",
        groupeTaxe: "",
        type:"Nouveau"
      });
      showHeader.value = true;
    };

    const calculTotal = () => {
      let total = 0;
      enfants.forEach((enfant) => {
        if (parseFloat(enfant.montant) > 0) {
          total += parseFloat(enfant.montant);
        }
      });
      montantContrat.value = parseFloat((loyerBasePlace.value ?? 0).toString()) + parseFloat((caution.value ?? 0).toString()) + ((groupeDeTaxeSelected.value && groupeDeTaxeSelected.value == 5) ? parseFloat((montantTPS.value ?? 0).toString()) : 0) + total;
      console.log("Montant contrat:", montantContrat.value);
    };

    const valideteRowElement = (e) => {
      if (e == "" || e == 0 || e == "0" || e == null || e < 0) {
        return true;
      } else {
        return false;
      }
    };

    const removeRowElement = async (index) => {
      if (index > -1) enfants.splice(index, 1);
      await calculTotal();
    };

    onMounted(async () => {
      
      await getAllActivite();
      await getAllGroupeTaxe();
      await getAllElement();
      if (route.params.id) {
        await getContrat(parseInt(route.params.id as string));
      }
    });

    const tableaux = ref<any[]>([]);

    const chargerCler = (element, index) => {
      console.log('Element selected:', element);
      enfants[index].prix = element.split('-')[1];
      tableaux.value.push(element.split('-')[0]);
    };

    const placeSelectionner = async (event) => {
      loyerBasePlace.value = parseInt(event.split('-')[1]);
      caution.value = parseInt(event.split('-')[1]) * 2;
      montantTPS.value = parseInt(event.split('-')[1]) * 0.05;
      await calculTotal();
      // usagermentSelected.value = marchand;
    };
    watch(placeId, async (newPlaceId) => {
      if (newPlaceId) {
        try {
          const { data } = await ApiService.get(`/places/${newPlaceId}`);
          loyerBasePlace.value = data.data.loyerBase;
          placeSelected.value = true;
        } catch (err) {
          console.error(err);
          error("Erreur lors de la récupération des détails.");
          placeSelected.value = false;
        }
      } else {
        placeSelected.value = false;
      }
    });

    watch(groupeDeTaxeSelected, (newValue) => {
      if (newValue && newValue != null && newValue == 5) {
        estTPS.value = true;
        // REAJUSTEMENT DES ELEMENTS
        enfants.forEach((enfant, index) => {
          enfants[index].groupeTaxe = "5";
        });

      } else {
        estTPS.value = false;
      }
    });

    watch(enfants, async (newValue) => {
      newValue.forEach((enfant, index) => {
        if (enfant.quantite && enfant.prix) {
          enfants[index].montant = (parseFloat(enfant.quantite) * parseFloat(enfant.prix)).toString();
        }
        // 
        if (estTPS.value) {
          enfants[index].groupeTaxe = "5";
          nextTick(() => {
            enfants[index].groupeTaxe = "5"; // Force update
          });
          // je veux bloquer le select aussi

        }
      });
      await calculTotal();
    }, { deep: true });
    const usagerSelected = ref(0);
    const usagersOptions = ref([]);
    const placeOptions = ref([]);


    const fetchPlaces = async (key) => {
      try {
        const response = await axios.get(`/places/recherche/${key}`);
        const placesData = response.data.data;
        placeOptions.value = placesData.map((place) => (
          {
            value: `${place.id + '-' + place.loyerBase}`,
            label: `${place.code} - [${place.marche?.libelle}] - ${place?.type?.type?.libelle}`,
          }));
        if (placeOptions.value.length == 0) {
          noOptionsTextAbb.value = noResultText;
        } else {
          noOptionsTextAbb.value = 'Tapez au moins trois caractères';
        }
        return placeOptions.value;
      } catch (error) {
        //
      }
    }

    const fetchUsagers = async (key) => {
      try {
        usagerSelected.value = parseInt(usagermentSelected.value.split('-')[1]);
        const response = await axios.get(`/usagers/recherche/${key}?usagerSelected=${usagerSelected.value}`);
        const usagersData = response.data.data;
        usagersOptions.value = usagersData.map((usager) => ({
          value: usager.id,
          label: (usager.typeUsager == null || usager.typeUsager == "Personne physique") ? (usager.nom + " " + usager.prenom + ' [ ' + ((usager.numtel) ? usager.numtel : 'NF') + ' ]' + `${usager.npi ? " - " + usager.npi : ""}`) : (usager.raisonSocial + `${usager.rccm ? ' [ ' + usager.rccm + ' ]' : ''}` + `${usager.ifu ? " - IFU : " + usager.ifu : ""}`),
        }));
        return usagersOptions.value;
      } catch (error) {
        //
      }
    }

    const fetchActivites = async (key) => {
      try {
        activiteSelected.value = parseInt(activitementSelected.value.split('-')[1]);
        const response = await axios.get(`/activites/recherche/${key}?activiteSelected=${activiteSelected.value}`);
        const activitesData = response.data.data;
        activitesOptions.value = activitesData.map((activite) => ({
          value: activite.id,
          label: activite.libelle,
        }));
        return activitesOptions.value;
      } catch (error) {
        //
      }
    }
    return {
      toggleMarchand,
      toggleActivite,
      togglePlace,
      selectedPlace,
      selectedMarchand,
      selectedActivite,
      placeOption,
      marchandOption,
      activiteOption,
      fetchActivites,
      activitesOptions,
      activitementSelected,
      fetchPlaces,
      usagersOptions,
      usagerSelected,
      fetchUsagers,
      addRowElement,
      tableaux,
      chargerCler,
      estTPS,
      auclic,
      enfants,
      contratForm,
      noOptionsTextAbb,
      noResultText,
      contratSchema,
      valideteRowElement,
      placeSelectionner,
      removeRowElement,
      editContrat,
      montantTPS,
      caution,
      typeOptions,
      categorieOptions,
      groupeDeTaxeSelected,
      serviceOptions, typeentretienOptions,
      showMErr,
      elementOptions,
      types,
      typeentretiens,
      categories,
      services,
      groupeTaxeOption,
      montantContrat,
      loyerBasePlace,
      placeSelected,
      isDisable,
      showHeader,
      placeId,
      placeS,
      usagerS,
      activiteS,
      aib,
      loyerAib,

    };
  },
});
</script>